import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Menu, X, ChevronDown } from 'lucide-react'
import { Button } from '../ui/button'
import { useTranslation } from 'react-i18next'
import LanguageSelector from '../LanguageSelector'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [productsOpen, setProductsOpen] = useState(false)
  const { t } = useTranslation()

  const products = [
    { name: t('products.cattleFeed'), path: '/products/cattle-feed' },
    { name: t('products.indianRice'), path: '/products/rice' },
    { name: t('products.pulses'), path: '/products/pulses' },
    { name: t('products.spices'), path: '/products/spices' },
    { name: t('products.cereals'), path: '/products/cereals' },
  ]

  return (
    <nav className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center py-2">
          <Link to="/" className="flex-shrink-0 flex items-center group">
            <div className="relative">
              <img 
                src='/logo.jpeg' 
                alt='KSD Ventures Logo' 
                className='h-10 w-10 rounded-full object-contain transition-transform duration-300 group-hover:scale-105' 
              />
            </div>
            <div className="ml-3 flex items-baseline">
              <span className="text-2xl font-bold text-gray-900 tracking-tight">KSD</span>
              <span className="text-lg font-medium text-yellow-400 ml-1.5">Ventures</span>
              <span className='text-base text-gray-500 ml-1.5 font-light'>Pvt</span>
              <span className='text-base text-gray-500 ml-1 font-light'>Ltd</span>
            </div>
          </Link>
    </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8 rtl:space-x-reverse">
            <Link to="/" className="text-gray-700 hover:text-primary transition">{t('nav.home')}</Link>
            
            {/* Products Dropdown */}
            <div className="relative group">
              <button className="flex items-center text-gray-700 hover:text-primary transition">
                {t('nav.products')} <ChevronDown className="ml-1 rtl:mr-1 rtl:ml-0 h-4 w-4" />
              </button>
              <div className="absolute left-0 mt-2 w-48 bg-white rounded-xl shadow-xl border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 overflow-hidden">
                {products.map((product) => (
                  <Link
                    key={product.path}
                    to={product.path}
                    className="block px-4 py-2.5 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-700 transition-colors"
                  >
                    {product.name}
                  </Link>
                ))}
              </div>
            </div>
            
            <Link to="/about" className="text-gray-700 hover:text-primary transition">{t('nav.about')}</Link>
            <Link to="/contact" className="text-gray-700 hover:text-primary transition">{t('nav.contact')}</Link>
            <Link to="/become-partner" className="text-gray-700 hover:text-primary transition">{t('nav.partner')}</Link>
            <LanguageSelector />
            <Button asChild>
              <Link to="/get-quote">{t('nav.getQuote')}</Link>
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-700">
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden pb-4">
            <Link to="/" className="block py-2 text-gray-700 hover:text-primary">{t('nav.home')}</Link>
            
            {/* Mobile Products Dropdown */}
            <div className="py-2">
              <button 
                onClick={() => setProductsOpen(!productsOpen)}
                className="flex items-center text-gray-700 hover:text-primary w-full"
              >
                {t('nav.products')} <ChevronDown className={`ml-1 rtl:mr-1 rtl:ml-0 h-4 w-4 transition-transform ${productsOpen ? 'rotate-180' : ''}`} />
              </button>
              {productsOpen && (
                <div className="pl-4 mt-2 space-y-2">
                  {products.map((product) => (
                    <Link
                      key={product.path}
                      to={product.path}
                      className="block py-1 text-sm text-gray-600 hover:text-primary"
                    >
                      {product.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
            
            <Link to="/about" className="block py-2 text-gray-700 hover:text-primary">{t('nav.about')}</Link>
            <Link to="/contact" className="block py-2 text-gray-700 hover:text-primary">{t('nav.contact')}</Link>
            <Link to="/become-partner" className="block py-2 text-gray-700 hover:text-primary">{t('nav.partner')}</Link>
            <div className="py-2">
              <LanguageSelector />
            </div>
            <Button asChild className="w-full mt-2">
              <Link to="/get-quote">{t('nav.getQuote')}</Link>
            </Button>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navbar
